/**
 * @author yueheqin
 * @date 2018/12/13
 * @project kaoshizhongxin-pc
 * @description 用户中心
 */
import request from '../utils/request'
import {API_URL, API_LOGOUT_URL} from '../config'
import { uploadFile } from '../utils/upload-file'

const user = {
  userInfo: API_URL + 'v1/user/member-info',
  userIndex: API_URL + 'v1/user/member-center',
  getGrade: API_URL + 'v1/user/grade',
  getArea: API_URL + 'v1/user/area',
  updateUserInfo: API_URL + 'v1/user/member-update',
  updateUserPhone: API_URL + 'v1/user/member-update-phone',
  editPwd: API_LOGOUT_URL + 'api/web/update-password',
  uploadUserPic: API_URL + 'v1/user/member-pic',
  collectTest: API_URL + 'v1/collect/test',
  collectCatalog: API_URL + 'v1/collect/catalog',
  catalogCreate: API_URL + 'v1/collect/catalog-create',
  catalogUpdate: API_URL + 'v1/collect/catalog-update',
  catalogDelete: API_URL + 'v1/collect/catalog-delete',
  testMove: API_URL + 'v1/collect/test-move',
  docSave: API_URL + 'v1/user/doc-save',
  docRecovery: API_URL + 'v1/paper/recovery',
  docSaveDel: API_URL + 'v1/user/doc-save-delete',
  docDown: API_URL + 'v1/user/doc-down',
  docDownDel: API_URL + 'v1/user/doc-down-delete',
  testCommentList: API_URL + 'v1/user/test-comment',
  testInfo: API_URL + 'v1/user/test-info',
  orderList: API_URL + 'v1/user/order',
  orderDel: API_URL + 'v1/user/order-delete',
  orderPay: API_URL + 'v1/user/order-pay'
}

// 个人信息
export const getUserInfoApi = () => request.get(user.userInfo)

// 个人信息首页
export const userIndexApi = () => request.get(user.userIndex)

// 获取年级
export const getGradeApi = () => request.get(user.getGrade)

// 获取省市区
export const getAreaApi = (params, config) => request.get(user.getArea, {...params, config})

// 修改个人信息
export const updateUserInfoApi = (data, config) => request.post(user.updateUserInfo, data, config)

// 修改个人绑定手机号
export const updateUserPhoneApi = (data, config) => request.post(user.updateUserPhone, data, config)

// 修改密码
export const editPwdApi = (data, config) => request.post(user.editPwd, data, config)

// 上传头像
export const uploadUserPicUrl = user.uploadUserPic
export const uploadUserPicApi = (data, config) => uploadFile.post(user.uploadUserPic, data, config)

// 个人题库-题库试题列表
export const collectTestApi = (params, config) => request.get(user.collectTest, {params, ...config})

// 个人题库-题库目录
export const collectCatalogApi = (params, config) => request.get(user.collectCatalog, {params, ...config})

// 个人题库-创建目录
export const catalogCreateApi = (data, config) => request.post(user.catalogCreate, data, config)

// 个人题库-修改目录
export const catalogUpdateApi = (data, config) => request.post(user.catalogUpdate, data, config)

// 个人题库-删除目录
export const catalogDeleteApi = (params, config) => request.get(user.catalogDelete, {params, ...config})

// 个人题库-移动试题
export const testMoveApi = (data, config) => request.post(user.testMove, data, config)

// 存档记录
export const docSaveApi = (params, config) => request.get(user.docSave, {params, ...config})

// 恢复存档记录
export const docRecoveryApi = (params, config) => request.get(user.docRecovery, {params, ...config})

// 存档记录删除
export const docSaveDelApi = (params, config) => request.get(user.docSaveDel, {params, ...config})

// 下载记录
export const docDownApi = (params, config) => request.get(user.docDown, {params, ...config})

// 下载记录删除
export const docDownDelApi = (params, config) => request.get(user.docDownDel, {params, ...config})

// 试题评价记录
export const testCommentListApi = (params, config) => request.get(user.testCommentList, {params, ...config})

// 试题评价记录
export const testInfoApi = (params, config) => request.get(user.testInfo, {params, ...config})

// 订单列表
export const orderListApi = (params, config) => request.get(user.orderList, {params, ...config})

// 订单删除
export const orderDelApi = (params, config) => request.get(user.orderDel, {params, ...config})

// 订单支付
export const orderPayApi = (params, config) => request.get(user.orderPay, {params, ...config})
